// Tabler Icons (MIT) inlined as SVG strings for the launcher. Source:
//   https://github.com/tabler/tabler-icons  →  icons/outline/*.svg
//
// The loader stays dependency-free, and inline markup survives a host page
// with a strict CSP (no external sprites). `stroke="currentColor"` lets the
// launcher's on-colour text colour drive them. The panel uses lucide-react.

import type { WidgetLauncherIcon } from './widget-config'

const SVG_BASE =
  'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"'

const svg = (paths: string): string => `<svg ${SVG_BASE}>${paths}</svg>`

/** tabler `message-circle` */
const MESSAGE = svg(
  '<path d="M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1" />',
)

export const LAUNCHER_ICONS: Record<Exclude<WidgetLauncherIcon, 'avatar'>, string> = {
  message: MESSAGE,
  /** tabler `message-dots` */
  'message-dots': svg(
    '<path d="M12 11v.01" /><path d="M8 11v.01" /><path d="M16 11v.01" /><path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z" />',
  ),
  /** tabler `messages` */
  messages: svg(
    '<path d="M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10" /><path d="M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2" />',
  ),
  /** tabler `help-circle` */
  help: svg(
    '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M12 16v.01" /><path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />',
  ),
  /** tabler `headset` */
  headset: svg(
    '<path d="M4 14v-3a8 8 0 1 1 16 0v3" /><path d="M18 19c0 1.657 -2.686 3 -6 3" /><path d="M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z" /><path d="M15 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z" />',
  ),
}
